import { useEffect, useState } from 'react';
import { RenderConfigScreenCtx } from 'datocms-plugin-sdk';
import { Canvas, SwitchField } from 'datocms-react-ui';

type Props = {
  ctx: RenderConfigScreenCtx;
};

export default function ConfigScreen({ ctx }: Props) {
  const params = ctx.plugin.attributes.parameters;
  const [ ampExpIsActive, setAmpExpIsActive ] = useState(params.ampExpBlockNameCustomizerIsActive as boolean);
  const [ nestedBlocksIsActive, setNestedBlocksIsActive ] = useState(params.nestedBlocksTitleIsActive as boolean);

  useEffect(() => {
    const current = ctx.plugin.attributes.parameters;
    // Skip the write when nothing changed (e.g. on mount) so we don't push a
    // redundant parameter update back to the iframe
    if (
      current.ampExpBlockNameCustomizerIsActive === ampExpIsActive &&
      current.nestedBlocksTitleIsActive === nestedBlocksIsActive
    ) {
      return;
    }
    (async() => {
      await ctx.updatePluginParameters({
        ampExpBlockNameCustomizerIsActive: ampExpIsActive,
        nestedBlocksTitleIsActive: nestedBlocksIsActive,
      })
    })()
  // ctx intentionally omitted — it changes reference on every render and would cause an infinite loop
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ampExpIsActive, nestedBlocksIsActive])

  return (
    <Canvas ctx={ctx}>
       <SwitchField
        name="activate"
        id="activate"
        label="Show Amplitude Experiment in block titles?"
        hint="Blocks with a value in their Amplitude Experiment field show the experiment and variant as their title."
        value={ampExpIsActive}
        onChange={(newValue: boolean) => setAmpExpIsActive(newValue)}
      />
       <SwitchField
        name="nestedBlocks"
        id="nestedBlocks"
        label="List nested blocks in block titles?"
        hint="Blocks that contain child blocks list them in their collapsed title, e.g. “FAQ Group 🪺 FAQ Item ×4”."
        value={nestedBlocksIsActive}
        onChange={(newValue: boolean) => setNestedBlocksIsActive(newValue)}
      />
    </Canvas>
  );
}
